// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AwardItem_award__oEcOy {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 25px;
}
.AwardItem_award__oEcOy .AwardItem_title__TcmUU {
  font-size: 14px;
  font-weight: 600;
  color: var(--blue);
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;
}
.AwardItem_award__oEcOy .AwardItem_title__TcmUU:hover {
  text-decoration: underline;
  color: rgb(from var(--blue) r g b/50%) !important;
}
.AwardItem_award__oEcOy .AwardItem_award-number__rKE0C {
  font-size: 12px;
}
.AwardItem_award__oEcOy .AwardItem_sponsors__79F1A {
  font-size: 12px;
}
.AwardItem_award__oEcOy .AwardItem_coauthors__nrSJq {
  font-size: 12px;
}
.AwardItem_award__oEcOy .AwardItem_section-title__yexZi {
  color: var(--grey-text);
  font-weight: 500;
  font-size: 12px;
}

@media only screen and (max-width: 480px) {
  .AwardItem_section-title__yexZi {
    text-decoration: underline;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/AwardItem/AwardItem.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AACJ;AACI;EACE,0BAAA;EACA,iDAAA;AACN;AAGE;EACE,eAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;AAME;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;AAJJ;;AAQA;EACE;IACE,0BAAA;EALF;AACF","sourcesContent":[".award {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 25px;\n\n  .title {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--blue);\n    text-decoration: none;\n    transition: all 0.2s ease;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n      color: rgb(from var(--blue) r g b / 50%) !important;\n    }\n  }\n\n  .award-number {\n    font-size: 12px;\n  }\n\n  .sponsors {\n    font-size: 12px;\n  }\n\n  .coauthors {\n    font-size: 12px;\n  }\n\n  .section-title {\n    color: var(--grey-text);\n    font-weight: 500;\n    font-size: 12px;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .section-title {\n    text-decoration: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"award": `AwardItem_award__oEcOy`,
	"title": `AwardItem_title__TcmUU`,
	"award-number": `AwardItem_award-number__rKE0C`,
	"sponsors": `AwardItem_sponsors__79F1A`,
	"coauthors": `AwardItem_coauthors__nrSJq`,
	"section-title": `AwardItem_section-title__yexZi`
};
export default ___CSS_LOADER_EXPORT___;
